import { buildManilaIso, toManilaParts } from "../../utils/manilaTime";

// All correction queries share this prefix so one invalidation refreshes them.
export const CORRECTION_KEY = "me:corrections";

export const CORRECTION_STATUS = {
  PENDING: { label: "Waiting for approval", tone: "amber" },
  APPROVED: { label: "Approved", tone: "green" },
  REJECTED: { label: "Rejected", tone: "red" },
  CANCELLED: { label: "Cancelled", tone: "gray" },
};

export const ADD_SESSION = "new";
export const MAX_REASON = 500;

// Deployed employees can't request corrections: HR fixes their days.
export const isDeployed = (profile) =>
  String(profile?.profile?.assignmentType || profile?.assignmentType || "")
    .toLowerCase()
    .startsWith("deployed");

/** ISO → "HH:mm" in Manila, or "". */
export const timeOf = (iso) => (iso ? toManilaParts(iso).time : "");

/**
 * Form → POST body, or { error }.
 * form: { sessionId (id | ADD_SESSION), checkIn "HH:mm", checkOut "HH:mm", reason }
 * session: the chosen session's current times (to send only what changes).
 */
export const buildCorrection = (date, form, session) => {
  const reason = (form.reason || "").trim();
  if (!reason) return { error: "Say why the record needs fixing." };
  const adding = form.sessionId === ADD_SESSION;
  if (adding && !form.checkIn)
    return { error: "Enter the check-in time of the missing record." };
  if (form.checkIn && form.checkOut && form.checkOut <= form.checkIn)
    return { error: "Check-out must be after check-in." };
  const body = { date, reason };
  if (!adding) body.sessionId = form.sessionId;
  const inChanged = adding || form.checkIn !== timeOf(session?.checkInTime);
  const outChanged = adding || form.checkOut !== timeOf(session?.checkOutTime);
  if (form.checkIn && inChanged)
    body.checkInTime = buildManilaIso(date, form.checkIn);
  if (form.checkOut && outChanged)
    body.checkOutTime = buildManilaIso(date, form.checkOut);
  if (!adding && !body.checkInTime && !body.checkOutTime)
    return { error: "Change the check-in or check-out time first." };
  return { body };
};
